
<app-nav-logo></app-nav-logo>


<div class="content">

    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-3 col-lg-3"></div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12
                text-center">
                <div class="row">
                    <!-- Label ข้อมูลสหกรณ์ -->
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <button class="btn-hover color-9" id="TypeCoop" (click)="coop_page()">ข้อมูลสหกรณ์</button>
                    </div>
                    <!-- Label ข้อมูลกลุ่มเกษตรกร -->
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <button class="btn-hover color-5 active">ข้อมูลกลุ่มเกษตรกร</button>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3"></div>
        </div>
    </div>

    <ng-container>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-12">
                    <div class="content-tab">
                        <ul class="nav nav-pills" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="pill" (click)="agri_page('Agri')">ข้อมูลทั่วไป</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" (click)="agri_page('Agri-Insert')">ค้นหาข้อมูลราย เขต /
                                    ภาค</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" (click)="agri_page('Agri-Assets')">อุปกรณ์การตลาด</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="pill" (click)="agri_page('Agri-Machine')">เครื่องจักรกลการเกษตร</a>
                            </li>
                        </ul>

                        <!-- Tab panes -->
                        <div class="container-fluid">
                            <div class="row">
                                <div class="tab-content">
                                    <div id="info" class="tab-pane active">
                                        <div class="container-fluid mb-2">
                                            <div class="row" style="height: 20px;">
                                                <div class="col" style="text-align: right;">
                                                    <i class="fa fa-eye fa-2x" aria-hidden="true"
                                                        style="width: 25px; vertical-align: middle; padding-bottom: 2px; color: black;"></i>
                                                    จำนวนผู้เข้าชม : {{viewer}} ครั้ง
                                                </div>
                                            </div>
                                            <div class="row mt-4">
                                                <div class="col" style="text-align: right;">
                                                    ภาคการเกษตร
                                                    <select class="form-select mr-3" name="list_sector" id="list_sector"
                                                        (change)="selectNewYearAndSector('',$event.target.value)"
                                                        [(ngModel)]="sector_now">
                                                        <option *ngFor="let x of listsector" value="{{x.value}}">
                                                            {{x.name}}</option>
                                                    </select>
                                                    ข้อมูล ณ ปี
                                                    <select class="form-select" name="list_year" id="list_year" (change)="selectNewYearAndSector($event.target.value,'')" [(ngModel)]="year_now">
                                                        <option *ngFor="let y of listYear" value="{{y}}">{{y}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12">
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">จำนวนกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12">
                                                                            <h6 class="text-center p-2 mt-3">ข้อมูล ณ
                                                                                วันที่
                                                                                {{Date_after_day}} {{Month_now_}}
                                                                                {{year_now_}}
                                                                            </h6>
                                                                        </div>
                                                                        <div
                                                                            class="col-xl-12 col-md-12 col-sm-12 d-flex">
                                                                            <div class="col-xl-4 col-lg-4 col-md-4">
                                                                                <img src="/assets/images/vegetables.png"
                                                                                    class="w-100" alt="">
                                                                            </div>
                                                                            <div
                                                                                class="col-xl-8 col-lg-8 col-lg-8 text-center p-0">
                                                                                <!-- <span>สหกรณ์</span> -->
                                                                                <p class="content-user mt-auto mb-auto">
                                                                                    {{CoopOracleCount |
                                                                                    number:'':'he'}} แห่ง
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div id="chartdiv_AN"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header pb-0">
                                                                    <h6 class="font-weight-bold">จำนวนสมาชิกกลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/farmer-m.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศชาย</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{MemberYearDataM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/farmer-fm.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศหญิง</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{MemberYearDataFm
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12 text-center mt-2">
                                                                            <span>สมาชิกรวม</span>
                                                                            <p class="content-user mt-auto mb-auto">
                                                                                {{MemberYearDataSum |
                                                                                number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 mb-4 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header card-header-nav pb-0 pt-0">
                                                            <div
                                                                class="tab col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-3">
                                                                <ul class="nav nav-tabs col-xl-12 text-center">
                                                                    <li class="">
                                                                        <a class="" id="coop_"
                                                                            [ngClass]="(coop_ == true)?'active':''"
                                                                            (click)="CoopNav($event.target.id)"
                                                                            role="tab">จำนวนกลุ่มเกษตรกร</a>
                                                                    </li>
                                                                    <li class="">
                                                                        <a class="" id="memberCoop_"
                                                                            [ngClass]="(memberCoop_  == true)?'active':''"
                                                                            (click)="memberCoopNav($event.target.id)"
                                                                            role="tab">จำนวนสมาชิกกลุ่มเกษตรกร</a>
                                                                    </li>
                                                                    <li class="">
                                                                        <a class="" id="committeeCoop_"
                                                                            [ngClass]="(committeeCoop_ == true)?'active':''"
                                                                            (click)="committeeCoopNav($event.target.id)"
                                                                            role="tab">ปริมาณธุรกิจกลุ่มเกษตรกร</a>
                                                                    </li>
                                                                    <!-- <li class="" *ngIf="shortComings_verify == true">
                                                                        <a class="" id="shortComingsCoop_"
                                                                            [ngClass]="(shortComingsCoop_ == true)?'active':''"
                                                                            (click)="shortComingsCoopNav($event.target.id)"
                                                                            role="tab">ข้อบกพร่อง</a>
                                                                    </li> -->
                                                                </ul>
                                                            </div>
                                                        </div>

                                                        <div class="card-body p-2">
                                                            <ng-container *ngIf="coop_">
                                                                <h4 class="text-center p-2 mt-3">จำนวนกลุ่มเกษตรกร</h4>
                                                                <div class="row">
                                                                    <div
                                                                        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                                        <h6 class="text-center  p-2 mt-3">ข้อมูล ณ
                                                                            วันที่ {{Date_after_day}}
                                                                            {{Month_now_}} {{year_now_}}
                                                                        </h6>
                                                                    </div>
                                                                    <div
                                                                        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                                        <h6 class="text-center p-2 mt-3">(
                                                                            จำนวนรวมทั้งหมด หน่วย : แห่ง )
                                                                        </h6>
                                                                    </div>
                                                                    <div class="col-lg-12">
                                                                        <div id="Coop_regions">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                            <ng-container *ngIf="memberCoop_">
                                                                <h4 class="text-center p-2 mt-4">จำนวนสมาชิกกลุ่มเกษตรกร</h4>
                                                                <h6 class="text-center p-2 mt-3">( จำนวนรวมทั้งหมด หน่วย
                                                                    : คน )
                                                                </h6>
                                                                <div id="MapMember">
                                                                </div>
                                                            </ng-container>
                                                            <ng-container *ngIf="committeeCoop_">
                                                                <h4 class="text-center p-2 mt-4">ปริมาณธุรกิจกลุ่มเกษตรกร</h4>
                                                                <h6 class="text-center p-2 mt-3">( หน่วย : ล้านบาท )
                                                                </h6>
                                                                <div id="Coop_regions_member">
                                                                </div>
                                                                <hr>
                                                            </ng-container>
                                                            <ng-container *ngIf="shortComingsCoop_">
                                                                <h4 class="text-center p-2 mt-4">ข้อบกพร่อง</h4>
                                                                <h6 class="text-center p-2 mt-3">( จำนวนรวมทั้งหมดเทียบกับจำนวนกลุ่มเกษตรกรที่ Active หน่วย
                                                                    : ร้อยละ )
                                                                </h6>
                                                                <div id="Coop_Shortcomings">
                                                                </div>
                                                                <hr>
                                                            </ng-container>
                                                            <!-- <div class="col-xl-12 text-right mt-5">
                                                                <p>ที่มา : กรมส่งเสริมกลุ่มเกษตรกร
                                                                </p>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12">
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header">
                                                                    <h6 class="font-weight-bold">จำนวนกรรมการ
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-3">
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/employee1.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศชาย</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CommitteeYearM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/employee.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศหญิง</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CommitteeYearFM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12 text-center mt-2">
                                                                            <span>กรรมการ</span>
                                                                            <p class="content-user mt-auto mb-auto">
                                                                                {{CommitteeYear | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-6 col-sm-12 mt-4">
                                                            <div class="card h-100">
                                                                <div class="card-header">
                                                                    <h6 class="font-weight-bold">จำนวนเจ้าหน้าที่กลุ่มเกษตรกร
                                                                    </h6>
                                                                </div>
                                                                <div class="card-body p-3">
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/steward.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศชาย</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CoopOfficerYearMemberM
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 mt-2 text-center">
                                                                        <div class="col-xl-4">
                                                                            <img src="/assets/images/stewardess.png"
                                                                                class="img-staff" alt="">
                                                                        </div>
                                                                        <div class="col-xl-8 mt-auto mb-auto">
                                                                            <span class="content-user2">เพศหญิง</span>
                                                                            <p class="content-user3 mt-auto mb-auto">
                                                                                {{CoopOfficerYearMemberFm
                                                                                | number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row p-0 m-0">
                                                                        <div class="col-xl-12 text-center mt-2">
                                                                            <span>พนักงาน</span>
                                                                            <p class="content-user mt-auto mb-auto">
                                                                                {{CoopOfficerYearMember |
                                                                                number:'':'he'}} คน
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <!-- <div class="col-xl-6 col-sm-12 mt-4"> -->
                                                <div class="col-xl-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header">
                                                            <div class="col-lg-12 col-md-12">
                                                                <h6 class="font-weight-bold">มาตรฐานกลุ่มเกษตรกร</h6>
                                                            </div>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12 text-right">
                                                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                                                </p>
                                                            </div>
                                                            <div id="chartdiv_Standard">
                                                            </div>
                                                            <!-- <div class="col-xl-12 text-right">
                                                                <p>ที่มา : กรมส่งเสริมกลุ่มเกษตรกร
                                                                </p>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-xl-6 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header">
                                                            <div class="col-lg-12 col-md-12">
                                                                <h6 class="font-weight-bold">ระดับขั้นความเข้มแข็ง</h6>
                                                            </div>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12 text-right">
                                                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                                                </p>
                                                            </div>
                                                            <div id="chartdiv_Strong">
                                                            </div>
                                                            <div class="d-none"
                                                                *ngFor="let items of standard; index as i">
                                                                <div *ngIf="i == 0">
                                                                    <div class="card-body p-3">
                                                                        <div class="col-xl-12 col-lg col-md-12
                                                                            mt-3
                                                                            d-flex">
                                                                            <i class="fas
                                                                                fa-check-circle"></i>
                                                                            <p class="ml-3
                                                                                content-p
                                                                                mt-auto
                                                                                mb-auto" thousandSeparator=",">
                                                                                {{items.sum_standard_pass |
                                                                                number:'':'he'}} แห่ง
                                                                            </p>
                                                                            <span class="mt-auto
                                                                                mb-auto
                                                                                ml-2">({{persent_standard_pass|
                                                                                number:'2.1-2'}}
                                                                                %)</span>
                                                                        </div>
                                                                        <div class="col-xl-12
                                                                            col-lg-12
                                                                            col-md-12
                                                                            mt-4
                                                                            d-flex">
                                                                            <i class="fas
                                                                                fa-times-circle"></i>
                                                                            <p class="ml-3
                                                                                content-p
                                                                                mt-auto
                                                                                mb-auto" thousandSeparator=",">
                                                                                {{items.sum_standard_not |
                                                                                number:'':'he'}} แห่ง
                                                                            </p>
                                                                            <span class="mt-auto
                                                                                mb-auto
                                                                                ml-2">({{persent_standard_not
                                                                                |
                                                                                number:'2.1-2'}}
                                                                                %)</span>
                                                                        </div>
                                                                        <div class="col-lg-12
                                                                            col-md-12
                                                                            mt-4
                                                                            tex-center">
                                                                            <p class="ml-3
                                                                                mt-auto
                                                                                mb-auto
                                                                                tex-center
                                                                                total-sum" thousandSeparator=",">รวม
                                                                                {{sumstandard | number:'':'he'}} แห่ง
                                                                            </p>
                                                                        </div>
                                                                        <div class="col-lg-12">
                                                                            <hr>
                                                                            <div class="row
                                                                                mt-2">
                                                                                <div class="col-xl-12
                                                                                    col-md-12
                                                                                    col-sm-12
                                                                                    col-xs-12
                                                                                    d-flex">
                                                                                    <div class="bg-pass"></div>
                                                                                    <p class="m-0
                                                                                        pl-3">
                                                                                        ผ่านมาตรฐานกลุ่มเกษตรกร
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row
                                                                                mt-2">
                                                                                <div class="col-xl-12
                                                                                    col-md-12
                                                                                    col-sm-12
                                                                                    col-xs-12
                                                                                    d-flex">
                                                                                    <div class="bg-notpass"></div>
                                                                                    <p class="m-0
                                                                                        pl-3">
                                                                                        ไม่ผ่านมาตรฐานกลุ่มเกษตรกร
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 text-right">
                                                                <p>ที่มา : กรมส่งเสริมกลุ่มเกษตรกร
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-md-6 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">จำนวนกลุ่มเกษตรกร ทุกประเภท
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12">
                                                                <div class="table-responsive">
                                                                    <table class="table table-bordered m-0">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th colspan="2" class="text-center">
                                                                                    สถานะ</th>
                                                                                <th colspan="2" class="text-center">
                                                                                    มาตรฐาน</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="text-center table-success">
                                                                                    Active</th>
                                                                                <th class="text-center table-danger">
                                                                                    Non-active</th>
                                                                                <th class="text-center table-success">
                                                                                    ผ่าน</th>
                                                                                <th class="text-center table-danger">
                                                                                    ไม่ผ่าน</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{Active_coopType1 |
                                                                                    number: '':'he'}}</td>
                                                                                <td>{{InActive_coopType1 |
                                                                                    number: '':'he'}}</td>
                                                                                <td>{{StandardTypeSum_pass |
                                                                                    number: '':'he'}}</td>
                                                                                <td>
                                                                                    {{StandardTypeSum_notPass | number:
                                                                                    '':'he'}}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <!-- <table class="table table-bordered">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th colspan="4" class="text-center">
                                                                                    ระดับขั้นความเข้มแข็ง</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 1</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 2</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 3</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 4</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{TypeLevelSum1 | number:'':'he'}}
                                                                                </td>
                                                                                <td>{{TypeLevelSum2 | number:'':'he'}}
                                                                                </td>
                                                                                <td>{{TypeLevelSum3 | number:'':'he'}}
                                                                                </td>
                                                                                <td>{{TypeLevelSum4 | number:'':'he'}}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-md-6 col-sm-12 mt-4"
                                                    *ngFor="let items of CoopOracleTypes ; let i = index;">
                                                    <div class="card h-100"
                                                        *ngIf="items.coopType == '1' || items.coopType == '2' || items.coopType == '3' || items.coopType == '4' || items.coopType == '5' || items.coopType == '6' || items.coopType == '7'">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold" *ngIf="items.coopType == '1'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำนา
                                                            </h6>
                                                            <h6 class="font-weight-bold" *ngIf="items.coopType == '2'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่
                                                            </h6>
                                                            <h6 class="font-weight-bold" *ngIf="items.coopType == '3'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน
                                                            </h6>
                                                            <h6 class="font-weight-bold" *ngIf="items.coopType == '4'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง
                                                            </h6>
                                                            <h6 class="font-weight-bold" *ngIf="items.coopType == '5'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                                            </h6>
                                                            <h6 class="font-weight-bold" *ngIf="items.coopType == '6'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ
                                                            </h6>
                                                            <!-- <h6 class="font-weight-bold" *ngIf="items.coopType == '7'">
                                                                จำนวนกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเครดิตยูเนี่ยน
                                                            </h6> -->
                                                        </div>
                                                        <div class="card-body">
                                                            <div class="col-xl-12">
                                                                <div class="table-responsive">
                                                                    <table class="table table-bordered m-0">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th colspan="2" class="text-center">
                                                                                    สถานะ</th>
                                                                                <th colspan="2" class="text-center">
                                                                                    มาตรฐาน</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="text-center table-success">
                                                                                    Active</th>
                                                                                <th class="text-center table-danger">
                                                                                    Non-active</th>
                                                                                <th class="text-center table-success">
                                                                                    ผ่าน</th>
                                                                                <th class="text-center table-danger">
                                                                                    ไม่ผ่าน</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{{items.active | number:'':'he'}}
                                                                                </td>
                                                                                <td>{{items.nonActive | number:'':'he'}}
                                                                                </td>

                                                                                <td *ngIf="items.coopType == '1'">
                                                                                    {{StandardType_pass_level1 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '1'">
                                                                                    {{StandardType_notPass_level1 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '2'">
                                                                                    {{StandardType_pass_level2 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '2'">
                                                                                    {{StandardType_notPass_level2 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '3'">
                                                                                    {{StandardType_pass_level3 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '3'">
                                                                                    {{StandardType_notPass_level3 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '4'">
                                                                                    {{StandardType_pass_level4 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '4'">
                                                                                    {{StandardType_notPass_level4 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '5'">
                                                                                    {{StandardType_pass_level5 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '5'">
                                                                                    {{StandardType_notPass_level5 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '6'">
                                                                                    {{StandardType_pass_level6 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '6'">
                                                                                    {{StandardType_notPass_level6 |
                                                                                    number:'':'he'}}</td>
                                                                                <!-- <td *ngIf="items.coopType == '7'">
                                                                                    {{StandardType_pass_level7 |
                                                                                    number:'':'he'}}</td>
                                                                                <td *ngIf="items.coopType == '7'">
                                                                                    {{StandardType_notPass_level7 |
                                                                                    number:'':'he'}}</td> -->

                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <!-- <table class="table table-bordered">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th colspan="4" class="text-center">
                                                                                    ระดับขั้นความเข้มแข็ง</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 1</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 2</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 3</th>
                                                                                <th class="text-center">
                                                                                    ชั้นที่ 4</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td *ngIf="items.coopType == '1' ">
                                                                                    {{TypeLevel1_type1 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '2' ">
                                                                                    {{TypeLevel1_type2 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '3' ">
                                                                                    {{TypeLevel1_type3 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '4' ">
                                                                                    {{TypeLevel1_type4 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '5' ">
                                                                                    {{TypeLevel1_type5 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '6' ">
                                                                                    {{TypeLevel1_type6 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '7' ">
                                                                                    {{TypeLevel1_type7 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '1' ">
                                                                                    {{TypeLevel2_type1 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '2' ">
                                                                                    {{TypeLevel2_type2 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '3' ">
                                                                                    {{TypeLevel2_type3 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '4' ">
                                                                                    {{TypeLevel2_type4 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '5' ">
                                                                                    {{TypeLevel2_type5 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '6' ">
                                                                                    {{TypeLevel2_type6 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '7' ">
                                                                                    {{TypeLevel2_type7 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '1' ">
                                                                                    {{TypeLevel3_type1 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '2' ">
                                                                                    {{TypeLevel3_type2 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '3' ">
                                                                                    {{TypeLevel3_type3 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '4' ">
                                                                                    {{TypeLevel3_type4 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '5' ">
                                                                                    {{TypeLevel3_type5 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '6' ">
                                                                                    {{TypeLevel3_type6 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '7' ">
                                                                                    {{TypeLevel3_type7 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '1' ">
                                                                                    {{TypeLevel4_type1 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '2' ">
                                                                                    {{TypeLevel4_type2 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '3' ">
                                                                                    {{TypeLevel4_type3 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '4' ">
                                                                                    {{TypeLevel4_type4 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '5' ">
                                                                                    {{TypeLevel4_type5 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '6' ">
                                                                                    {{TypeLevel4_type6 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                                <td *ngIf="items.coopType == '7' ">
                                                                                    {{TypeLevel4_type7 |
                                                                                    number:'':'he'}}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">สินทรัพย์ของกลุ่มเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_asset"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset1"
                                                                    (click)="asset1()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">หนี้สินของกลุ่มเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_debt">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset2"
                                                                    (click)="asset2()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">ทุนของกลุ่มเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_Capital">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset3"
                                                                    (click)="asset3()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">กำไร(ขาดทุน)ของกลุ่มเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12 p-0">
                                                                <div id="chartdiv_profit">
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#asset4"
                                                                    (click)="asset4()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-4">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ รวมทุกประเภทกลุ่มเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#myModal"
                                                                    (click)="myModal()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                ประเภทกลุ่มเกษตรกรทำนา
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type1"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type1"
                                                                    (click)="Type1()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำไร่
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type2"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type2"
                                                                    (click)="Type2()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรทำสวน
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type3"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type3"
                                                                    (click)="Type3()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                ประเภทกลุ่มเกษตรกรประมง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type4"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type4"
                                                                    (click)="Type4()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type5"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type5"
                                                                    (click)="Type5()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทกลุ่มเกษตรกรอื่นๆ
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type6"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type6"
                                                                    (click)="Type6()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ
                                                                ประเภทสหกรณ์เครดิตยูเนี่ยน
                                                            </h6>
                                                        </div>
                                                        <div class="card-body
                                                            p-0">
                                                            <div class="col-xl-12">
                                                                <div id="chartdiv_business_type7"></div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal" data-target="#Type7"
                                                                    (click)="Type7()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกร
                                                                ทุกประเภท
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_coop_sum">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation"
                                                                    (click)="Participation()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำนา
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_coop">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation1"
                                                                    (click)="Participation1()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำไร่
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_fishing">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation2"
                                                                    (click)="Participation2()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรทำสวน
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_Settlement">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation3"
                                                                    (click)="Participation3()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรประมง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_saving">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation4"
                                                                    (click)="Participation4()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรเลี้ยงสัตว์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_shop">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation5"
                                                                    (click)="Participation5()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิก กลุ่มเกษตรกรอื่นๆ
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_service">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation6"
                                                                    (click)="Participation6()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกสหกรณ์
                                                                ประเภทเครดิตยูเนี่ยน
                                                            </h6>
                                                        </div>
                                                        <div class="card-body">
                                                            <div id="chartdiv_Participation_credit">
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="modal"
                                                                    data-target="#Participation7"
                                                                    (click)="Participation7()">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <!-- <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4" *ngIf="ViewOAE_1">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนเกษตรกร
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_1.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่ (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_1.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="collapse"
                                                                    data-target="#collapse1"
                                                                    (click)="GetViewOAEDetailByGroup('1')">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4" *ngIf="ViewOAE_2">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนเลี้ยงสัตว์
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_2.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่ (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_2.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="collapse"
                                                                    data-target="#collapse2"
                                                                    (click)="GetViewOAEDetailByGroup('2')">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4" *ngIf="ViewOAE_3">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนประมง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_3.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่ (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{ViewOAE_3.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-12 mt-3 mb-3 text-right">
                                                                <a href="" data-toggle="collapse"
                                                                    data-target="#collapse3"
                                                                    (click)="GetViewOAEDetailByGroup('3')">ดูเพิ่มเติม</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4" *ngIf="rubber_sum">
                                                    <div class="card h-100">
                                                        <div class="card-header
                                                            pb-0">
                                                            <h6 class="font-weight-bold">ทะเบียนผู้ปลูกยาง
                                                            </h6>
                                                        </div>
                                                        <div class="card-body p-3">
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/farmer-m.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนคน</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{rubber_sum.total_count}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="row p-0 mt-2 text-center">
                                                                <div class="col-xl-4">
                                                                    <img src="/assets/images/icon_land.png"
                                                                        class="img-staff" alt="">
                                                                </div>
                                                                <div class="col-xl-8 mt-auto mb-auto">
                                                                    <span class="content-user2">จำนวนพื้นที่ (ไร่)</span>
                                                                    <p class="content-user3 mt-auto mb-auto">
                                                                        {{rubber_sum.total_rai}}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>

                                            <!-- <div class="accordion collapse-zone" id="accordion">
                                                <div class="collapse collapse-zone" id="collapse1" data-parent="#accordion">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-0 mt-4">
                                                        <div class="card card-body p-2">
                                                            <table class="table table-hover">
                                                                <thead>
                                                                    <tr class="table-active text-center">
                                                                        <th scope="col"></th>
                                                                        <th scope="col" style="font-size: 15px;">ลำดับ</th>
                                                                        <th scope="col" style="font-size: 15px;">ประเภท</th>
                                                                        <th scope="col" style="font-size: 15px;">จำนวนสมาชิก (คน)</th>
                                                                        <th scope="col" style="font-size: 15px;">พื้นที่เพาะปลูก (ไร่)</th>
                                                                    </tr>
                                                                </thead>
                                                                <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนเกษตรกร
                                                                </th>
                                                                <tbody *ngFor="let items of ViewOAE_1_detail; index as i">
                                                                    <tr>
                                                                        <th></th>
                                                                        <td scope="row" class="table-active" style="font-size: 15px;">{{i+1}}</td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.type}}</td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.total_count}} </td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.total_rai}} </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="collapse collapse-zone" id="collapse2" data-parent="#accordion">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-0 mt-4">
                                                        <div class="card card-body p-2">
                                                            <table class="table table-hover">
                                                                <thead>
                                                                    <tr class="table-active text-center">
                                                                        <th scope="col"></th>
                                                                        <th scope="col" style="font-size: 15px;">ลำดับ</th>
                                                                        <th scope="col" style="font-size: 15px;">ประเภท</th>
                                                                        <th scope="col" style="font-size: 15px;">จำนวนสมาชิก (คน)</th>
                                                                        <th scope="col" style="font-size: 15px;">พื้นที่เพาะปลูก (ไร่)</th>
                                                                    </tr>
                                                                </thead>
                                                                <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนเลี้ยงสัตว์
                                                                </th>
                                                                <tbody *ngFor="let items of ViewOAE_2_detail; index as i">
                                                                    <tr>
                                                                        <th></th>
                                                                        <td scope="row" class="table-active" style="font-size: 15px;">{{i+1}}</td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.typeDetail}}</td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.total_count}} </td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.total_rai}} </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="collapse collapse-zone" id="collapse3" data-parent="#accordion">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-0 mt-4">
                                                        <div class="card card-body p-2">
                                                            <table class="table table-hover">
                                                                <thead>
                                                                    <tr class="table-active text-center">
                                                                        <th scope="col"></th>
                                                                        <th scope="col" style="font-size: 15px;">ลำดับ</th>
                                                                        <th scope="col" style="font-size: 15px;">ประเภท</th>
                                                                        <th scope="col" style="font-size: 15px;">จำนวนสมาชิก (คน)</th>
                                                                        <th scope="col" style="font-size: 15px;">พื้นที่เพาะปลูก (ไร่)</th>
                                                                    </tr>
                                                                </thead>
                                                                <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนประมง
                                                                </th>
                                                                <tbody *ngFor="let items of ViewOAE_3_detail; index as i">
                                                                    <tr>
                                                                        <th></th>
                                                                        <td scope="row" class="table-active" style="font-size: 15px;">{{i+1}}</td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.typeDetail}}</td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.total_count}} </td>
                                                                        <td scope="row" style="font-size: 15px;">{{items.total_rai}} </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->

                                        </div>

                                    </div>
                                    <div id="resert" class="tab-pane fade">
                                    </div>
                                    <div id="asset_" class="tab-pane fade">
                                    </div>
                                    <div id="machine_" class="tab-pane fade">
                                        <app-coop-machine></app-coop-machine>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>



    <div class="container">
        <div class="row">
            <div id="myModal" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรับฝากเงิน</h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_deposit"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_lend"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_products"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต</h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_produce"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_Processing"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_service"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Type1" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type1_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type1_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type1_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type1_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type1_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำนา ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type1_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Type2" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type2_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type2_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type2_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type2_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type2_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำไร่ ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type2_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Type3" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรับฝากเงิน</h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type3_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type3_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type3_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทรวบรวมผลผลิต</h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type3_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type3_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรทำสวน ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type3_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Type4" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type4_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type4_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type4_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type4_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type4_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรประมง ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type4_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Type5" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรับฝากเงิน</h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type5_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type5_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type5_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type5_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type5_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรเลี้ยงสัตว์ ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type5_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Type6" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรับฝากเงิน</h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type6_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type6_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type6_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type6_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type6_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจกลุ่มเกษตรกรอื่นๆ ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type6_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div id="Type7" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type7_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type7_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน
                                                ประเภทจัดหาสินค้ามาจำหน่าย

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type7_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type7_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type7_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">ปริมาณธุรกิจสหกรณ์เครดิตยูเนี่ยน ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_business_type7_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div> -->

            <div id="asset1" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">สินทรัพย์ของกลุ่มเกษตรกร
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำนา
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำไร่
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำสวน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type3">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรประมง
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type4">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรเลี้ยงสัตว์
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type5">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรอื่นๆ
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type6">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">
                                                        สหกรณ์เครดิตยูเนี่ยน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_asset_type7">
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="asset2" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">หนี้สินของกลุ่มเกษตรกร
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำนา
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_debt_type1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำไร่
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_debt_type2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำสวน
                                                    </h6>
                                                </div>
                                                <div id="chartdiv_debt_type3">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรประมง
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_debt_type4">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรเลี้ยงสัตว์
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_debt_type5">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรอื่นๆ
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_debt_type6">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4s">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">
                                                        สหกรณ์เครดิตยูเนี่ยน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_debt_type7">
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="asset3" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">ทุนของกลุ่มเกษตรกร
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 mt-4">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำนา
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำไร่
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำสวน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type3">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรประมง
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type4">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรเลี้ยงสัตว์
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type5">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรอื่นๆ
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type6">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">
                                                        สหกรณ์เครดิตยูเนี่ยน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_Capital_type7">
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="asset4" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">กำไร (ขาดทุน)ของกลุ่มเกษตรกร
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 mt-4">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำนา
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำไร่
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรทำสวน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type3">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรประมง
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type4">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรเลี้ยงสัตว์
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type5">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">กลุ่มเกษตรกรอื่นๆ
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type6">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                            <div class="card h-100">
                                                <div class="card-header pb-0">
                                                    <h6 class="font-weight-bold">
                                                        สหกรณ์เครดิตยูเนี่ยน
                                                    </h6>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div id="chartdiv_profit_type7">
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ทุกประเภท
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation1" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทสกลุ่มเกษตรกรทำนา
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type1_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation2" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำไร่
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type2_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation3" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรทำสวน
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type3_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation4" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรประมง
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type4_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation5" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรเลี้ยงสัตว์
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type5_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Participation6" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <!-- Modal content-->
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทกลุ่มเกษตรกรอื่นๆ
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type6_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div id="Participation7" class="modal fade" role="dialog">
                <div class="modal-dialog col-12">
                    <div class="modal-content col-12">
                        <div class="modal-header">
                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทสหกรณ์เครดิตยูเนี่ยน
                            </h6>
                            <button type="button" class="close text-right" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรับฝากเงิน
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_deposit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทให้เงินกู้
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_credit_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทจัดหาสินค้ามาจำหน่าย
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_sale_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทรวบรวมผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_collect_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร
                                                ประเภทแปรรูปผลผลิต
                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_transfrom_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทบริการ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_service_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mt-4">
                                    <div class="card h-100">
                                        <div class="card-header pb-0">
                                            <h6 class="font-weight-bold">การมีส่วนร่วมของสมาชิกกลุ่มเกษตรกร ประเภทอื่น ๆ

                                            </h6>
                                        </div>
                                        <div class="card-body p-0">
                                            <div class="col-xl-12">
                                                <div id="chartdiv_Participation_type7_other_val"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default text-right" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
    <app-footer></app-footer>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>
